import type { PostalCodeCityModel } from '@/types/ReferenceData/PostalCode.ts'
import { apiGetOrNull } from '../ApiClient'

/**
 * Looks up the city name for a Norwegian postal code.
 * Returns `null` when the postal code is unknown (HTTP 404).
 */
export async function getPostalCodeCity(postalCode: string): Promise<PostalCodeCityModel | null> {
  return apiGetOrNull<PostalCodeCityModel>(`/postal-codes/${encodeURIComponent(postalCode)}/city`)
}
